import { VersionStatus } from '../constants.tsx';

// @ts-expect-error TODO JPX-157
export const transformAggVersionToLegacyVersion = (version) => ({
	id: version.versionId ?? '',
	name: version.name ?? '',
	description: version.description ?? '',
	archived: version.status === VersionStatus.ARCHIVED,
	released: version.status === VersionStatus.RELEASED,
	ari: version.id,
});
